import { render, staticRenderFns } from "./jtwhatsapp.vue?vue&type=template&id=c1cd1ec0&scoped=true"
import script from "./jtwhatsapp.vue?vue&type=script&lang=js"
export * from "./jtwhatsapp.vue?vue&type=script&lang=js"
import style0 from "./jtwhatsapp.vue?vue&type=style&index=0&id=c1cd1ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cd1ec0",
  null
  
)

export default component.exports